import { render, staticRenderFns } from "./MobileMenuBody.vue?vue&type=template&id=08d0dc80&scoped=true"
import script from "./MobileMenuBody.vue?vue&type=script&lang=js"
export * from "./MobileMenuBody.vue?vue&type=script&lang=js"
import style0 from "./MobileMenuBody.vue?vue&type=style&index=0&id=08d0dc80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d0dc80",
  null
  
)

export default component.exports